module.exports = __webpack_public_path__ + "static/feature2.0314727f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/feature2.jpg
// module id = 1151
// module chunks = 213534597649335